export class ApiError extends Error {
  constructor(public status: number, public body: any) {
    super(`API ${status}: ${JSON.stringify(body)}`);
  }
}

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api/${path.replace(/^\//, "")}`, {
    headers: { "content-type": "application/json", ...(init?.headers ?? {}) },
    credentials: "include",
    ...init,
  });
  const text = await res.text();
  let body: any;
  try { body = text ? JSON.parse(text) : null; } catch { body = text; }
  if (!res.ok) throw new ApiError(res.status, body);
  return body as T;
}

export const api = {
  get:    <T>(path: string)               => call<T>(path),
  post:   <T>(path: string, body?: any)   => call<T>(path, { method: "POST",   body: JSON.stringify(body ?? {}) }),
  put:    <T>(path: string, body?: any)   => call<T>(path, { method: "PUT",    body: JSON.stringify(body ?? {}) }),
  del:    <T>(path: string)               => call<T>(path, { method: "DELETE" }),
};
